import Axios from "axios";

export const SelectNomenclatureAG = (a, b, c, d, e) => {
  return (dispatch) => {
    Axios.get(
      `https://www.24-crm.tn/webservice/api/NOME?cat=AG&coddos=${a}&serveur=${b}&user=${c}&pwd=${d}&database=${e}`
    ).then((response) => {
      return dispatch({
        type: "NOMENCLATUREAG_SELECT",
        payload: response.data,
      });
    });
  };
};
